import gql from 'graphql-tag';

export const GET_PROGRAM_STRUCTURES_WITH_REQUIREMENTS_FOR_PROGRAM = gql`
	query getProgramVersions($programVersionId: [String]) {
		programStructureEntitys(
			where: [{path: "programVersionId", comparison: equal, value: $programVersionId}]
		)
		{
			id
			description
			name
			created
			components {
				id
				displayName
				description
				condition
				order
				requirements {
					id
					displayName
					description
				}
			}
		}
	}
`;

export default {
	GET_PROGRAM_STRUCTURES_WITH_REQUIREMENTS_FOR_PROGRAM,
};
